<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="exchange_rate.exchange_rate_id && exchange_rate.exchange_rate_id > 0"
                                @invoke-method="dbGetExchangeRate(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="exchange_rate.exchange_rate_id && exchange_rate.exchange_rate_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('exchange_rates.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in exchange_rate_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != exchange_rate.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('exchange_rates.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_exchange_rate.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'exchange_rates' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                  <v-card elevation="10">
                      <v-card-text>
                        <div class="ribbon ribbon-top-right" :class="`ribbon-${exchange_rate.status_class}`"><span class="ribbon-span">{{ exchange_rate.status }}</span></div>
                        <v-form ref="formExchangeRate">
									<v-flex xs12>
										<v-text-field
											v-focus="exchange_rate_dialog"
											v-model="exchange_rate.exchange_rate_id"
											:label="$t('lang.exchange_rate_id')"
											:counter="showCounter(exchange_rate.exchange_rate_id, 'exchange_rates.exchange_rate_id')"
											:rules="ifValid('exchange_rates.exchange_rate_id')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<bc-autocomplete
											v-model="exchange_rate.from_currency_id"
											:label="`${$t('lang.from_currency_id')} *`"
											:items="from_currency_id"
											item-value="value"
											item-text="text"
											:rules="ifValid('exchange_rates.from_currency_id')"
										></bc-autocomplete>
									</v-flex>
									<v-flex xs12>
										<bc-autocomplete
											v-model="exchange_rate.to_currency_id"
											:label="`${$t('lang.to_currency_id')} *`"
											:items="to_currency_id"
											item-value="value"
											item-text="text"
											:rules="ifValid('exchange_rates.to_currency_id')"
										></bc-autocomplete>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="exchange_rate.rate"
											:label="`${$t('lang.rate')} *`"
											:counter="showCounter(exchange_rate.rate, 'exchange_rates.rate')"
											:rules="ifValid('exchange_rates.rate')"
										></v-text-field>
									</v-flex>


                            <div>
                                <h3>ExchangeRate Details</h3>
                                <v-data-table
                                    :headers="exchange_rate_headers"
                                    :items="exchange_rate.exchange_rate_details || []"
                                    item-key="exchange_rate_detail_id"
                                    :no-data-text="$t('lang.no_results_matching')"
                                    hide-actions
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr>
								<td>{{ props.item.exchange_rate_id }}</td>
								<td>{{ props.item.from_currency_id }}</td>
								<td>{{ props.item.to_currency_id }}</td>
								<td>{{ props.item.rate }}</td>
                                            <td>
                                                <v-icon @click="removeRow(props.index)">delete</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                                <div class="text-center">
                                    <v-btn
                                        tile
                                        color="primary"
                                        @click="addRow()">
                                        {{ $t("lang.add_more") }}
                                    </v-btn>
                                </div>
                            </div>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'exchange_rates' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveExchangeRates">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_exchange_rate"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_exchange_rate')"
                :message="$t('lang.delete_exchange_rate_confirm')"
                @onConfirm="deleteExchangeRates()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_exchange_rate_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteExchangeRateDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            exchange_rate_headers: [
                { text: this.$t("lang.exchange_rate_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.from_currency_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.to_currency_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.rate"), sortable: false, width: "25%" },
                { text: "", width: "3%", sortable: false },
            ],
            formData: {},
            exchange_rate: { exchange_rate_details: [] },
            file_name: "",
            dbGetExchangeRate: _.debounce(this.getExchangeRate, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchExchangeRate", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.exchange_rate) {
                        this.exchange_rate = this.assignObj2(data.exchange_rate, this.rules_exchange_rates);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=exchange_rate_status&sort_by=2",
                            method: "get",
                            stateProperty: "exchange_rate_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "exchange_rates", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchExchangeRate", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.exchange_rate) {
                        next((vm) => {
                            vm.exchange_rate = vm.assignObj2(data.exchange_rate, vm.rules_exchange_rates);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=exchange_rate_status&sort_by=2",
                                method: "get",
                                stateProperty: "exchange_rate_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "exchange_rates", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=exchange_rate_status&sort_by=2",
            method: "get",
            stateProperty: "exchange_rate_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_exchange_rates: (state) => state.exchange_rates.rules_exchange_rates,
            exchange_rate_status_options: (state) => state.settings.exchange_rate_status_options,
            exchange_rates: (state) => state.exchange_rates.exchange_rates,
            selectedExchangeRate: (state) => state.exchange_rates.selectedExchangeRate,
        }),
    },
    methods: {
        ...mapActions(["fetchExchangeRate", "saveExchangeRate", "deleteExchangeRate", "printExchangeRate"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        addRow() {
            if (!this.exchange_rate.exchange_rate_details) this.exchange_rate.exchange_rate_details = [];
            this.exchange_rate.exchange_rate_details.push({
                exchange_rate_id: `${this.$route.params.id}`,
                quantity: "",
                sales_unit: "",
                model_number: "",
                name: "",
            });
        },
        removeRow: function(index) {
            this.exchange_rate.exchange_rate_details.splice(index, 1);
        },
        getExchangeRate(pg_refresh = false) {
            this.startLoader();

            this.fetchExchangeRate({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.exchange_rate) {
                    this.exchange_rate = this.assignObj2(data.exchange_rate, this.rules_exchange_rates);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printExchangeRate({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.exchange_rate) {
                    if (this.dev_mode) {
                        this.file_name = data.exchange_rate.file_name;
                    } else {
                        this.$refs.print.printReport(data.exchange_rate.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveExchangeRates() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formExchangeRate")) {
                    let body = this.prepForm(this.exchange_rate, this.rules_exchange_rates);

                    this.saveExchangeRate({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.exchange_rate) {
                            this.$router.push({ name: "exchange_rate", params: { id: data.exchange_rate.exchange_rate_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { exchange_rate_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveExchangeRates({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.exchange_rate) {
                    this.exchange_rate = this.assignObj2(data.exchange_rate, this.rules_exchange_rates);
                }
            });
        },
        deleteExchangeRates() {
            this.deleteExchangeRate({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {
                    this.$refs.delete_exchange_rate_details.close();
                    this.validationOff();
                    this.$router.push({ name: "exchange_rates" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
    },
    created() {
        this.getCustomers();
    },
};
</script>
